;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"d51ba1c5"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.3.8";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = "https://web-in-test1.almmrc.com";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/agreement/:label\",\"regex\":\"^/([^/]+)/agreement/([^/]+)$\",\"paramNames\":[\"locale\",\"label\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/login\",\"regex\":\"^/([^/]+)/login$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/forbid\",\"regex\":\"^/([^/]+)/forbid$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/game-redirect\",\"regex\":\"^/([^/]+)/game-redirect$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/fantasy-record-single\",\"regex\":\"^/([^/]+)/fantasy-record-single$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/affiliate-invited\",\"regex\":\"^/([^/]+)/affiliate-invited$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/fantasy-invited\",\"regex\":\"^/([^/]+)/fantasy-invited$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/fruit-dart-invited\",\"regex\":\"^/([^/]+)/fruit-dart-invited$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/gsl-invited\",\"regex\":\"^/([^/]+)/gsl-invited$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/kol-affiliate-invited\",\"regex\":\"^/([^/]+)/kol-affiliate-invited$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/rummy-invited\",\"regex\":\"^/([^/]+)/rummy-invited$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/wheel-invited\",\"regex\":\"^/([^/]+)/wheel-invited$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/affiliate\",\"regex\":\"^/([^/]+)/affiliate$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/banner-detail\",\"regex\":\"^/([^/]+)/banner-detail$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino-activity/games\",\"regex\":\"^/([^/]+)/casino-activity/games$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino-activity/games/container\",\"regex\":\"^/([^/]+)/casino-activity/games/container$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino-activity/groups\",\"regex\":\"^/([^/]+)/casino-activity/groups$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/deposit-spin\",\"regex\":\"^/([^/]+)/deposit-spin$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/fantasy-record\",\"regex\":\"^/([^/]+)/fantasy-record$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/promo\",\"regex\":\"^/([^/]+)/promo$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/promotions\",\"regex\":\"^/([^/]+)/promotions$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/race\",\"regex\":\"^/([^/]+)/race$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/referral-wheel\",\"regex\":\"^/([^/]+)/referral-wheel$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/vip\",\"regex\":\"^/([^/]+)/vip$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/welcome-bonus\",\"regex\":\"^/([^/]+)/welcome-bonus$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/account\",\"regex\":\"^/([^/]+)/account$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/game-history\",\"regex\":\"^/([^/]+)/game-history$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/transaction-history\",\"regex\":\"^/([^/]+)/transaction-history$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino\",\"regex\":\"^/([^/]+)/casino$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games\",\"regex\":\"^/([^/]+)/casino/games$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games/blackjack\",\"regex\":\"^/([^/]+)/casino/games/blackjack$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games/dice\",\"regex\":\"^/([^/]+)/casino/games/dice$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games/limbo\",\"regex\":\"^/([^/]+)/casino/games/limbo$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games/mines\",\"regex\":\"^/([^/]+)/casino/games/mines$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games/plinko\",\"regex\":\"^/([^/]+)/casino/games/plinko$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games/container\",\"regex\":\"^/([^/]+)/casino/games/container$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games/detail\",\"regex\":\"^/([^/]+)/casino/games/detail$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/games/play\",\"regex\":\"^/([^/]+)/casino/games/play$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/groups\",\"regex\":\"^/([^/]+)/casino/groups$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/casino/groups/detail\",\"regex\":\"^/([^/]+)/casino/groups/detail$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/download\",\"regex\":\"^/([^/]+)/download$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/fantasy\",\"regex\":\"^/([^/]+)/fantasy$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/gsl\",\"regex\":\"^/([^/]+)/gsl$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/reward\",\"regex\":\"^/([^/]+)/reward$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/rummy\",\"regex\":\"^/([^/]+)/rummy$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/sports\",\"regex\":\"^/([^/]+)/sports$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:rest*\",\"regex\":\"^/([^/]+)/(.+)$\",\"paramNames\":[\"locale\",\"rest\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[{\"path\":\"/\"}],\"isrRoutes\":[\"/:locale/agreement/:label\",\"/:locale/forbid\",\"/:locale/:rest*\"]}";import * as Sentry from "@sentry/nextjs";
import { Env } from '@/libs/env';

const targetHostname = Env.NEXT_PUBLIC_HTTP_SERVER
  .replace(/^https?:\/\//, '')
  .replace(/\/+$/, '');

const environment = Env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || "development";

function hashCode(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
}

function getDeviceId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem('deviceId');
  } catch {
    return null;
  }
}

const getTracesSampleRate = () => {
  switch (environment) {
    case 'development':
      return 0;
    case 'test':
    case 'pre':
      return 1;
    case 'production':
      return 0.005;
    default:
      return 0;
  }
};

const getErrorSampleRate = () => {
  switch (environment) {
    case 'development':
      return 0;
    case 'test':
    case 'pre':
      return 1;
    case 'production':
      return 0.1;
    default:
      return 0;
  }
};

/**
 * 基于 deviceId 的一致性采样判断
 *
 * 原理：
 * 1. 将 deviceId 通过哈希函数转换为固定的数字
 * 2. 对哈希值取模（% 1000），得到 0-999 之间的固定值
 * 3. 判断该值是否小于阈值（5），决定是否采样
 *
 * 优势：
 * - 同一个 deviceId 每次计算结果相同 → 该设备的所有事件要么全采样，要么不采样
 * - 不同 deviceId 的哈希值均匀分布 → 整体采样率约为 5/1000 = 0.5%
 * - 可以追踪被采样设备的完整错误链路和用户行为
 *
 * @param deviceId 设备唯一标识
 * @returns true=采样, false=不采样, null=使用兜底随机采样
 */
function shouldSampleByDeviceId(deviceId: string | null): boolean | null {
  if (environment !== 'production') return null;
  if (deviceId) {
    const hash = hashCode(deviceId);
    return hash % 1000 < 5; // 0.5% 的设备
  }
  return null;
}

if (Env.NEXT_PUBLIC_ENABLE_SENTRY !== 'false') {
  Sentry.init({
    dsn: "https://00dda4b75a1afc89cdf9d9b75623dd92@sentry-new.sportdream.net/3",

    enableLogs: false,
    debug: false,
    environment,
    release: Env.RELEASE || "",
    attachStacktrace: false,

    initialScope: {
      tags: { brand: Env.NEXT_PUBLIC_BRAND },
    },
    maxBreadcrumbs: 50,

    ignoreErrors: [
      /adblock/i,
      /ad blocker/i,
      /failed to load resource/i,
      /blocked by client/i,
      /rejected/i,
      /NetworkError/i,
      /Network request failed/i,
      /extension context/i,
      /chrome-extension/i,
      /moz-extension/i,
      /Can't read property 'setItem' of null/i,
      /Cannot read property 'getItem' of null/i,
      /ResizeObserver loop/i,
      /Script error/i,
      /top.GLOBALS/i,
      /cancelled/i,
      /canceled/i,
      /AbortError/i,
      /\u5fae\u4fe1/i,
    ],

    ignoreTransactions: [
      /^\/_next\//,
      /\/favicon\.ico$/,
      /\/static\//,
    ],

    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: true,
        shouldCreateSpanForRequest: (url: string): boolean => {
          if (url.match(/\/health\/?$/)) return false;
          if (url.match(/\.(png|jpg|jpeg|gif|svg|ico|css|woff|woff2|ttf|eot|js|map)(\?.*)?$/i)) return false;

          try {
            const urlObj = new URL(url, location.href);
            if (urlObj.origin === location.origin) return true;
            if (urlObj.hostname === targetHostname || urlObj.host === targetHostname) return true;
            return false;
          } catch {
            return false;
          }
        },
      }),
      // 🔥 RewriteFrames: 将错误堆栈中的 app:/// 路径重写为实际 CDN 地址
      // 原因：静态资源托管在 CDN 上，Sentry 需要通过 CDN URL 匹配 Source Maps
      // 参考：https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/integrations/rewriteframes/
      Sentry.rewriteFramesIntegration({
        iteratee: (frame) => {
          if (!frame.filename) return frame;

          const cdnHost = Env.CDN_HOST;

          // 如果有 CDN 配置，将 app:/// 替换为 CDN 地址
          if (cdnHost && frame.filename.startsWith('app:///')) {
            frame.filename = frame.filename.replace('app:///', `${cdnHost}/`);
          }

          return frame;
        },
      }),
    ],

    tracesSampler: (samplingContext) => {
      const shouldSample = shouldSampleByDeviceId(getDeviceId());
      const op = samplingContext.transactionContext?.op;
      const isPageLoad = op === 'pageload' || op === 'navigation';

      if (shouldSample === true) return isPageLoad ? 0.5 : 1;
      if (shouldSample === false) return 0;

      const baseRate = getTracesSampleRate();
      return baseRate === 0 ? 0 : (isPageLoad ? baseRate * 0.5 : baseRate);
    },

    beforeSend(event, _hint) {
      // 全采样绕过：有 _force_send 标记的事件直接放行（100% 上报）
      // 跳过设备采样过滤，但仍应用生产环境数据精简
      // 注意：此路径不过滤无堆栈错误（error boundary 可能无堆栈但仍需统计）
      if (event.tags?.['_force_send'] === 'true') {
        delete event.tags['_force_send']; // 清理内部标记，不暴露给 Sentry UI
        if (environment === 'production') {
          if (event.breadcrumbs && event.breadcrumbs.length > 30) {
            event.breadcrumbs = event.breadcrumbs.slice(-30);
          }
          if (event.request?.data && typeof event.request.data === 'string' && event.request.data.length > 10000) {
            event.request.data = '[Data too large, truncated]';
          }
        }
        return event;
      }

      const shouldSample = shouldSampleByDeviceId(getDeviceId());

      // 一致性采样：未被选中的设备不采样
      if (shouldSample === false) {
        return null;
      } else if (shouldSample === null) {
        // 兜底：使用随机采样（无 deviceId 或非生产环境）
        if (Math.random() > getErrorSampleRate()) return null;
      }

      // 生产环境数据精简
      if (environment === 'production') {
        // 过滤无堆栈的错误（通常无意义）
        if (event.exception?.values?.[0] && !event.exception.values[0].stacktrace) return null;

        // 限制 breadcrumbs 数量
        if (event.breadcrumbs && event.breadcrumbs.length > 30) {
          event.breadcrumbs = event.breadcrumbs.slice(-30);
        }

        // 截断过大的请求数据（防止敏感信息泄漏）
        if (event.request?.data && typeof event.request.data === 'string' && event.request.data.length > 10000) {
          event.request.data = '[Data too large, truncated]';
        }
      }

      return event;
    },

    beforeSendTransaction(event) {
      // 生产环境精简性能数据
      if (environment === 'production') {
        if (event.spans) {
          event.spans = event.spans.map(span => {
            if (span.data) {
              // 删除请求/响应体（数据量大且不重要）
              delete span.data['http.response.body'];
              delete span.data['http.request.body'];
              // 截断过长的 URL
              const httpUrl = span.data['http.url'];
              if (typeof httpUrl === 'string' && httpUrl.length > 200) {
                span.data['http.url'] = httpUrl.substring(0, 200) + '...';
              }
            }
            return span;
          });
        }
        // 限制 breadcrumbs 数量
        if (event.breadcrumbs && event.breadcrumbs.length > 20) {
          event.breadcrumbs = event.breadcrumbs.slice(-20);
        }
      }
      return event;
    },
  });

  const deviceId = getDeviceId();
  if (deviceId) {
    Sentry.setUser({ id: deviceId });
  } else {
    let attempts = 0;
    const interval = setInterval(() => {
      const newDeviceId = getDeviceId();
      if (newDeviceId || ++attempts >= 10) {
        if (newDeviceId) Sentry.setUser({ id: newDeviceId });
        clearInterval(interval);
      }
    }, 500);
  }
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
